<script setup lang="ts">
import { CheckboxIndicator, CheckboxRoot } from "reka-ui";

defineProps<{ disabled: boolean }>();
const checked = defineModel<boolean>("checked", { required: true });
</script>

<template>
  <div class="tw-rounded-full tw-p-1.5 has-[:hover:not(:disabled)]:tw-bg-black/15">
    <CheckboxRoot
      v-model="checked"
      class="tw-grid tw-size-4 tw-place-items-center tw-rounded tw-border tw-border-black/20 tw-bg-white tw-transition-transform active:tw-scale-95 disabled:tw-cursor-not-allowed data-[state=checked]:tw-bg-green-600"
      :disabled="disabled"
      @click.stop
    >
      <CheckboxIndicator class="tw-grid tw-place-items-center">
        <i class="fas fa-check tw-text-white" />
      </CheckboxIndicator>
    </CheckboxRoot>
  </div>
</template>
